import { SubscribeToBackInStockMessageType } from "@redotech/redo-model/conversation/message-parsers/subscribe-to-back-in-stock-message-parser";
import { memo } from "react";
import { HandleEmailInputFn } from "../common";
import { AiEmailInput } from "./ai-email-input";
import { ChatContentRenderer } from "./chat-content-renderer";
import {
  GenericConfirmedState,
  GenericRejectedState,
} from "./chat-content-states";
import { getConfirmedStateContent } from "./tool-message-utils";

export const SubscribeBackInStockToolMessage = memo(
  function SubscribeBackInStockToolMessage({
    message,
    readOnly,
    onEmailEntry,
    conversationId,
    buttonText,
    messageSide = "left",
  }: {
    message: SubscribeToBackInStockMessageType;
    readOnly: boolean;
    onEmailEntry?: HandleEmailInputFn | undefined;
    conversationId: string;
    buttonText: string;
    messageSide?: "left" | "right";
  }) {
    const productInfo = message.structuredContent;
    const variantCount = productInfo?.variantIds?.length || 0;

    const { title: confirmedTitle, subtitle: confirmedSubtitle } =
      getConfirmedStateContent(
        message,
        "Successfully subscribed to back in stock notifications",
        "Something went wrong subscribing to back in stock notifications.",
        `We'll notify you at ${productInfo?.customerEmail} when ${variantCount > 1 ? "these items are" : "this item is"} back in stock`,
      );

    return (
      <ChatContentRenderer
        contentByState={{
          pending: (
            <AiEmailInput
              buttonText={buttonText}
              conversationId={conversationId}
              message={message}
              messageSide={messageSide}
              onEmailEntry={onEmailEntry}
              readOnly={readOnly}
            />
          ),
          confirmed: (
            <GenericConfirmedState
              subtitle={confirmedSubtitle}
              title={confirmedTitle}
            />
          ),
          rejected: (
            <GenericRejectedState title="Unable to subscribe to notifications" />
          ),
        }}
        message={message}
      />
    );
  },
);
